module.exports = __webpack_public_path__ + "static/media/clue0302.578c890b.jpg";